import { useAPIQuery, BlanksDraftApi } from "melco-shared-logic";

export const useBlankReferences = (blankId: string) => {
  return useAPIQuery(
    BlanksDraftApi,
    ["blankReferences", blankId],
    async (api) => api.userBlankReferences({ id: blankId })
  );
};
